module.exports = __webpack_public_path__ + "img/change.d7978d8a.svg";